import { jsx as s, jsxs as o } from "react/jsx-runtime";
import { cn as a } from "./index22.mjs";
const c = ({ sortOrder: e }) => {
  const t = !!e, r = t && e === "asc";
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: a("shrink-0", t ? r ? "[&_*]:data-[asc]:stroke-gray-900" : "[&_*]:data-[desc]:stroke-gray-900" : void 0),
      children: /* @__PURE__ */ o("g", { children: [
        /* @__PURE__ */ s(
          "path",
          {
            d: "M14.0001 10.667L11.3334 13.3337L8.66675 10.667",
            stroke: !r && t ? "stroke-gray-900" : "#A8A8A8",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            "data-desc": "true"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M11.3333 13.3337V2.66699",
            stroke: !r && t ? "stroke-gray-900" : "#A8A8A8",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            "data-desc": "true"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M2 5.33366L4.66667 2.66699L7.33333 5.33366",
            stroke: r && t ? "stroke-gray-900" : "#A8A8A8",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            "data-asc": "true"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            d: "M4.66675 2.66699V13.3337",
            stroke: r && t ? "stroke-gray-900" : "#A8A8A8",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            "data-asc": "true"
          }
        )
      ] })
    }
  );
};
export {
  c as default
};
